
export default {
  name: 'CartProductListSkeleton',
  props: {
    rows: {
      type: Number,
      default: 1,
    },
  },
}
